// Cookie.js

import React from "react";
import "../styles/Cookie.css";

export default function Cookie() {
  return (
    <section className="cookie-page">
      <div className="cookie-container">

        <h1>Cookie Policy</h1>
        <p><strong>Last updated:</strong> May 2026</p>

        <p>
          This website uses cookies and similar technologies to ensure proper
          functionality and improve user experience.
        </p>

        <h2>1. What Are Cookies?</h2>

        <p>
          Cookies are small text files stored on your device when visiting a
          website. They help websites function properly and provide information
          about how visitors use the site.
        </p>

        <h2>2. Types of Cookies We Use</h2>

        <h3>Essential Cookies</h3>

        <p>
          These cookies are necessary for the website to function correctly and
          cannot be disabled.
        </p>

        <h3>Analytics Cookies</h3>

        <p>
          We may use analytics services, such as Firebase Analytics, to
          understand how visitors interact with our website and improve website
          performance.
        </p>

        <p>
          Analytics cookies collect anonymous or aggregated information and do
          not directly identify individual visitors.
        </p>

        <h2>3. Managing Cookies</h2>

        <p>
          You can control or disable cookies through your browser settings.
        </p>

        <p>
          Where required by law, we request your consent before using
          non-essential cookies.
        </p>

        <h2>4. Contact</h2>

        <p>
          If you have questions about this Cookie Policy or your privacy,
          please contact us:
        </p>

        <p>
          Email: restaurantmesogeios@email.com
          <br />
          Phone: +30 2661 045827
        </p>

      </div>
    </section>
  );
}